import { render, staticRenderFns } from "./sbms.vue?vue&type=template&id=625b61fc&scoped=true"
import script from "./sbms.vue?vue&type=script&lang=js"
export * from "./sbms.vue?vue&type=script&lang=js"
import style0 from "./sbms.vue?vue&type=style&index=0&id=625b61fc&lang=scss"
import style1 from "./sbms.vue?vue&type=style&index=1&id=625b61fc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625b61fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('625b61fc')) {
      api.createRecord('625b61fc', component.options)
    } else {
      api.reload('625b61fc', component.options)
    }
    module.hot.accept("./sbms.vue?vue&type=template&id=625b61fc&scoped=true", function () {
      api.rerender('625b61fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/messagejk/sbms.vue"
export default component.exports